export const isoToSortDate = (date) => {
  if (date) {
    // return new Date(date).toLocaleDateString('en-US', {
    //   year: 'numeric',
    //   month: 'long',
    //   day: 'numeric'
    // })
      const d = new Date(date);
    return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
  } else {
    return ' - '
  }
}
